import apiClient from './apiClient';

const mapBanner = (banner) => ({
  id: banner.id,
  type: banner.type,
  title: banner.title,
  subtitle: banner.subtitle,
  image: banner.image_url,
  link: banner.link_url,
  cta: banner.cta || banner.cta_text,
  order: banner.order,
  isActive: banner.is_active,
});

const mapHeroVideo = (banner) => ({
  id: banner.id,
  videoUrl: banner.video_url || banner.video_url_mp4,
  posterUrl: banner.poster_url || banner.image_url,
  title: banner.title || '',
  subtitle: banner.subtitle || '',
  ctaText: banner.cta || banner.cta_text || 'Alışverişe Başla',
  ctaLink: banner.link_url || banner.link || '/',
  isActive: banner.is_active,
});

/**
 * Get hero video banner (single active video for homepage hero)
 * @returns {Promise<Object|null>} Hero video config or null
 */
export const getHeroVideo = async () => {
  try {
    const response = await apiClient.get('/banners/hero-video', {
      params: { _t: Date.now() }, // Cache bust
    });
    const banner = response.data;
    const videoUrl = (banner?.video_url || banner?.video_url_mp4 || '').trim();
    return banner && videoUrl ? mapHeroVideo(banner) : null;
  } catch (error) {
    console.error('Error fetching hero video:', error);
    return null;
  }
};

/**
 * Get all active banners for hero carousel
 * @returns {Promise<Array>} Array of banner objects
 */
export const getHeroBanners = async () => {
  try {
    const response = await apiClient.get('/banners', {
      params: { type: 'hero', is_active: true },
    });
    return response.data.map(mapBanner);
  } catch (error) {
    console.error('Error fetching hero banners:', error);
    return [];
  }
};

/**
 * Get promotion banner
 * @returns {Promise<Object|null>} Promotion banner object or null
 */
export const getPromoBanner = async () => {
  try {
    const response = await apiClient.get('/banners', {
      params: { type: 'promo', is_active: true, limit: 1 },
    });
    const banner = response.data?.[0] || null;
    return banner ? mapBanner(banner) : null;
  } catch (error) {
    console.error('Error fetching promo banner:', error);
    return null;
  }
};
